import { DownloadFile, enqueueSnackbar } from 'actions';
import {
	GetSarpSitesRequest,
	GetSarpReportRequest,
	GetSarpSiteTableRequest,
	GetNopTrackerLastUpdateRequest
} from '../requests/SarpReportRequests';

export const GET_SARP_SITES = 'GET_SARP_SITES';
export const SET_SELECTED_SARP_SITES = 'SET_SELECTED_SARP_SITES';
export const GET_SARP_SITE_TABLE = 'GET_SARP_SITE_TABLE';
export const GET_LAST_NOP_TRACKER_UPDATE_DATE = 'GET_LAST_NOP_TRACKER_UPDATE_DATE';

const onGetSarpSites = (value) => ({
	type: GET_SARP_SITES,
	sarpSites: value
});

export const GetSarpSites = () => async (dispatch) => {
	await GetSarpSitesRequest().then(response => {
		dispatch(onGetSarpSites(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onSetSelectedSarpSites = (value) => ({
	type: SET_SELECTED_SARP_SITES,
	selectedSarpSites: value
});

export const SetSelectedSarpSites = (selectedSarpSites) => (dispatch) => {
	dispatch(onSetSelectedSarpSites(selectedSarpSites));
};

export const GetSarpReport = (selectedSarpSites, username, userId ) => async (dispatch) =>{    
	await GetSarpReportRequest(selectedSarpSites, username, userId ).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetSarpSiteTable = (value) => ({
	type: GET_SARP_SITE_TABLE,
	sarpSiteTable: value
});

export const GetSarpSiteTable = () => async (dispatch) => {
	await GetSarpSiteTableRequest().then(response => {
		dispatch(onGetSarpSiteTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetNopTrackerLastUpdate = (value) => ({
	type: GET_LAST_NOP_TRACKER_UPDATE_DATE,
	lastNopTrackerUpdateDate: value
});

export const GetNopTrackerLastUpdate = () => async (dispatch) => {
	await GetNopTrackerLastUpdateRequest().then(response => {
		dispatch(onGetNopTrackerLastUpdate(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
